<nav [class.active]="!menubarIsCollapsed" class="navbar navbar-expand-lg navbar-dark fixed-top">
  <div class="container justify-content-lg-start">
    <div [class.active]="!menubarIsCollapsed" class="main-navigation order-0 order-lg-1">
      <ng-container [ngTemplateOutlet]="menubarTemplate"></ng-container>
    </div>

    <div class="order-1 order-lg-0 flex-grow-1">
      <ng-container [ngTemplateOutlet]="astrobinLogoTemplate"></ng-container>
    </div>

    <ul
      [class.active]="!userMenubarIsCollapsed"
      class="nav user-navigation order-2 d-flex d-lg-none align-items-center"
    >
      <ng-container [ngTemplateOutlet]="userMenubarTemplate"></ng-container>
    </ul>
  </div>
</nav>

<ng-template #astrobinLogoTemplate>
  <a
    *ngIf="!showMobileSearch"
    (click)="onLogoClick($event)"
    class="navbar-brand p-0 ps-3 pe-2 w-100 d-inline-block me-0 me-lg-3 position-relative"
  >
    <img class="d-block d-sm-none d-lg-block" alt="AstroBin" src="assets/images/nav-logo.png?v=3" />
    <h4 class="d-none d-sm-inline-block d-lg-none m-0 fw-bold">AstroBin</h4>
    <span *ngIf="versionCheckService.updateAvailable$ | async" class="version-update-badge">
      <fa-icon icon="circle-exclamation"></fa-icon>
    </span>
  </a>
  <ng-container *ngIf="showMobileSearch">
    <ng-container [ngTemplateOutlet]="quickSearchTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #quickSearchTemplate>
  <!-- Quick search form -->
  <form *ngIf="!isSearchPage" (submit)="onQuickSearchSubmit($event)" class="ps-3 pe-2 px-lg-4" method="get" ngNoForm>
    <label class="w-100 mb-0">
      <input
        #quickSearchInput
        class="form-control"
        [(ngModel)]="quickSearchQuery"
        autocomplete="off"
        name="q"
        placeholder="{{ 'Quick search' | translate }}"
        type="text"
      />
    </label>
    <input name="d" type="hidden" value="i" />
  </form>
  <!-- ./Quick search form -->
</ng-template>

<ng-template #menubarTemplate>
  <button
    [attr.aria-expanded]="!menubarIsCollapsed"
    (click)="openSidebarMenu()"
    class="navbar-toggler"
    aria-controls="navbarSupportedContent"
    aria-label="Toggle navigation"
    data-target="#navbarSupportedContent"
    data-toggle="collapse"
    type="button"
  >
    <fa-icon icon="bars"></fa-icon>
  </button>

  <div (click)="closeSidebarMenu()" class="overlay d-flex d-lg-none"></div>
  <ng-container [ngTemplateOutlet]="sidebarTemplate"></ng-container>
</ng-template>

<ng-template #userMenubarTemplate>
  <li *ngIf="!showMobileSearch" class="nav-item d-block d-lg-none">
    <ng-container [ngTemplateOutlet]="mobileSearchToggleTemplate"></ng-container>
  </li>

  <ng-container *ngIf="!!user; else loginAndRegisterTemplate">
    <li class="nav-item messages-list-item d-block d-lg-none">
      <ng-container [ngTemplateOutlet]="messagesButtonTemplate"></ng-container>
    </li>

    <li class="nav-item notifications-list-item d-block d-lg-none">
      <ng-container [ngTemplateOutlet]="notificationsButtonTemplate"></ng-container>
    </li>

    <li class="nav-item">
      <a
        [attr.aria-expanded]="!userMenubarIsCollapsed"
        (click)="openUserSidebarMenu()"
        class="d-lg-block ms-lg-2"
        aria-controls="userNavbarSupportedContent"
        aria-label="Toggle navigation"
        data-target="#userNavbarSupportedContent"
        data-toggle="collapse"
      >
        <astrobin-avatar [link]="false" [user]="user"></astrobin-avatar>
      </a>
    </li>

    <div (click)="closeUserSidebarMenu()" class="overlay d-flex d-xl-none"></div>
    <ng-container [ngTemplateOutlet]="userSidebarTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #languageSelectorTemplate>
  <!-- Language selector -->
  <li class="nav-item">
    <div ngbDropdown>
      <button id="languageDropdown" class="btn btn-link no-triangle" ngbDropdownToggle>
        {{ currentLanguageCodeDisplay }}
      </button>
      <div [attr.aria-labelledby]="'languageDropdown'" ngbDropdownMenu>
        <ng-container *ngFor="let language of languages">
          <a *ngIf="language.code !== '-'" [href]="getSetLanguageUrl(language.code)" class="dropdown-item">
            {{ language.label }}
          </a>
        </ng-container>

        <div class="dropdown-divider"></div>

        <a [attr.href]="helpWithTranslationsUrl" class="dropdown-item" target="_blank">
          <fa-icon icon="tasks"></fa-icon>
          {{ "Help with translations!" | translate }}
        </a>
      </div>
    </div>
  </li>
  <!-- ./Language selector -->
</ng-template>

<ng-template #mobileSearchToggleTemplate>
  <a *ngIf="!isSearchPage" (click)="onShowMobileSearchClick($event)" class="nav-link toggle-mobile-search d-lg-none">
    <fa-icon icon="search"></fa-icon>
  </a>
</ng-template>

<ng-template #messagesButtonTemplate>
  <!-- Messages -->
  <a class="btn btn-link nav-link position-relative messages-list-item" routerLink="/messages/inbox">
    <fa-icon icon="message"></fa-icon>
    <ng-container *ngIf="unreadMessagesCount$ | async as unreadCount">
      <span *ngIf="!!unreadCount" class="badge bg-danger badge-pill rounded-pill m-0">
        {{ unreadCount | numberSuffix }}
      </span>
    </ng-container>
  </a>
  <!-- ./Messages -->
</ng-template>

<ng-template #notificationsButtonTemplate>
  <!-- Notifications -->
  <a (click)="openNotificationsOffcanvas()" class="btn btn-link nav-link position-relative notifications-list-item">
    <fa-icon icon="bell"></fa-icon>
    <ng-container *ngIf="unreadNotificationsCount$ | async as unreadCount">
      <span *ngIf="!!unreadCount" class="badge bg-danger badge-pill rounded-pill m-0">
        {{ unreadCount | numberSuffix }}
      </span>
    </ng-container>
  </a>
  <!-- ./Notifications -->
</ng-template>

<ng-template #userMenuTemplate>
  <!-- User menu -->
  <li *ngIf="user && userProfile" class="nav-item d-none d-lg-inline">
    <div class="btn-group user-dropdown-toggle" ngbDropdown>
      <button class="btn btn-primary d-none d-xl-inline-block">
        <astrobin-username [user]="user"></astrobin-username>
        <ng-container [ngTemplateOutlet]="astrobinIndexTemplate"></ng-container>
      </button>

      <button id="user-dropdown" class="btn btn-primary mt-2 d-none d-xl-inline-block" ngbDropdownToggle></button>

      <ul [class.active]="!userMenubarIsCollapsed" class="nav user-navigation d-block d-xl-none">
        <ng-container [ngTemplateOutlet]="userMenubarTemplate"></ng-container>
      </ul>

      <div [attr.aria-labelledby]="'user-dropdown'" ngbDropdownMenu>
        <a [routerLink]="subscriptionsRoute" class="dropdown-item">
          <fa-icon icon="asterisk"></fa-icon>
          {{ "Subscriptions" | translate }}
        </a>

        <a class="dropdown-item" routerLink="/uploader">
          <fa-icon icon="upload"></fa-icon>
          {{ "Upload" | translate }}
        </a>

        <div class="dropdown-divider"></div>
        <h6 class="dropdown-header">{{ "My places" | translate }}</h6>

        <a *ngIf="user | isProducer" [href]="classicRoutesService.COMMERCIAL_PRODUCTS(user)" class="dropdown-item">
          <fa-icon icon="barcode"></fa-icon>
          {{ "Commercial products" | translate }}
        </a>

        <a
          [href]="userService.getGalleryUrl(user.username, userProfile.enableNewGalleryExperience)"
          (click)="userService.openGallery(user.username, userProfile.enableNewGalleryExperience)"
          class="dropdown-item"
          astrobinEventPreventDefault
        >
          <fa-icon icon="image"></fa-icon>
          {{ "Public Gallery" | translate }}
        </a>

        <a
          *ngIf="!userProfile.displayWipImagesOnPublicGallery"
          [href]="userService.getStagingUrl(user.username, userProfile.enableNewGalleryExperience)"
          (click)="userService.openStaging(user.username, userProfile.enableNewGalleryExperience)"
          class="dropdown-item"
          astrobinEventPreventDefault
        >
          <fa-icon icon="lock"></fa-icon>
          {{ "Staging Area" | translate }}
        </a>

        <div class="dropdown-divider"></div>

        <a class="dropdown-item" routerLink="/messages/inbox">
          <fa-icon icon="inbox"></fa-icon>
          {{ "Messages" | translate }}
        </a>

        <a [routerLink]="'/equipment/marketplace/users/' + user.username + '/listings'" class="dropdown-item">
          <fa-icon icon="shopping-cart"></fa-icon>
          {{ "Marketplace listings" | translate }}
        </a>

        <a [href]="classicRoutesService.API_KEYS(user)" class="dropdown-item">
          <fa-icon icon="key"></fa-icon>
          {{ "API Keys" | translate }}
        </a>

        <a [href]="classicRoutesService.SETTINGS" class="dropdown-item">
          <fa-icon icon="edit"></fa-icon>
          {{ "Settings" | translate }}
        </a>

        <a (click)="toggleHighContrastTheme($event)" class="dropdown-item">
          <fa-icon icon="adjust"></fa-icon>

          <ng-container *ngIf="!useHighContrastTheme(); else highContrastThemeEnabled">
            {{ "Enable high contrast theme" | translate }}
          </ng-container>
        </a>

        <div class="dropdown-divider"></div>

        <a (click)="logout($event)" class="dropdown-item" href="">
          <fa-icon icon="sign-out-alt"></fa-icon>
          {{ "Logout" | translate }}
        </a>
      </div>
    </div>
  </li>
  <!-- ./User menu -->
</ng-template>

<ng-template #uploadButtonTemplate>
  <!-- Upload button -->
  <li class="nav-item d-none d-lg-inline">
    <a class="btn btn-link nav-link d-inline-block ms-2 pe-0" routerLink="/uploader">
      <fa-icon icon="upload"></fa-icon>
    </a>
  </li>
  <!-- ./Upload button -->
</ng-template>

<ng-template #loginAndRegisterTemplate let-liClasses="liClasses">
  <ng-container *ngIf="!isAuthPage">
    <li [classList]="'nav-item ' + liClasses">
      <a class="nav-link" routerLink="/account/login" routerLinkActive="active">{{ "Log in" | translate }}</a>
    </li>
    <li [classList]="'nav-item ' + liClasses">
      <a class="nav-link" routerLink="/account/register" routerLinkActive="active">{{ "Sign up" | translate }}</a>
    </li>
  </ng-container>
</ng-template>

<ng-template #indexesPopoverContentTemplate>
  <ng-container *ngIf="userProfile">
    <h4>{{ "Image Index" | translate }}: {{ userProfile.astroBinIndex | number: "1.2-2" }}</h4>
    <div [innerHTML]="imageIndexPopoverInfo"></div>

    <hr />

    <h4>{{ "Contribution Index" | translate }} (beta): {{ userProfile.contributionIndex | number: "1.2-2" }}</h4>
    <div [innerHTML]="contributionIndexPopoverInfo"></div>
  </ng-container>
</ng-template>

<ng-template #sidebarTemplate>
  <div
    #sidebar
    class="order-lg-2 w-100 d-flex flex-row flex-wrap flex-lg-nowrap align-items-center align-content-between sidebar p-3 p-lg-0"
  >
    <ul class="navbar-nav mr-lg-auto mb-0 order-1 order-lg-0 justify-content-center">
      <li class="nav-item">
        <a class="nav-link d-lg-none" routerLink="/">
          {{ "Home" | translate }}
        </a>
      </li>

      <!-- Moderate menu -->
      <li *ngIf="user | isContentModerator" class="nav-item">
        <div ngbDropdown>
          <button id="moderateDropdown" class="btn btn-link" ngbDropdownToggle translate>Moderate</button>
          <div [attr.aria-labelledby]="'moderateDropdown'" ngbDropdownMenu>
            <h6 class="dropdown-header" translate>Images</h6>

            <a *ngIf="user | isImageModerator" [href]="classicRoutesService.MODERATE_IMAGE_QUEUE" class="dropdown-item">
              <fa-icon icon="images"></fa-icon>
              {{ "Image queue" | translate }}
            </a>

            <a
              *ngIf="(user | isImageModerator) && (user | isSuperUser)"
              [href]="classicRoutesService.MODERATE_SPAM_QUEUE"
              class="dropdown-item"
            >
              <fa-icon icon="flag"></fa-icon>
              {{ "Spam list" | translate }}
            </a>

            <ng-container *ngIf="user | isIotdStaff">
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header" translate>Image of the day</h6>

              <a *ngIf="user | isIotdSubmitter" class="dropdown-item" routerLink="/iotd/submission-queue">
                <fa-icon icon="upload"></fa-icon>
                {{ "Submission queue" | translate }}
              </a>

              <a *ngIf="user | isIotdReviewer" class="dropdown-item" routerLink="/iotd/review-queue">
                <fa-icon icon="star"></fa-icon>
                {{ "Review queue" | translate }}
              </a>

              <a *ngIf="user | isIotdJudge" class="dropdown-item" routerLink="/iotd/judgement-queue">
                <fa-icon icon="hammer"></fa-icon>
                {{ "Judgement queue" | translate }}
              </a>
            </ng-container>

            <ng-container *ngIf="user | isEquipmentModerator">
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header">Equipment</h6>

              <a class="dropdown-item" routerLink="/equipment/migration-tool">
                <fa-icon icon="arrow-right"></fa-icon>
                Migration tool
              </a>
            </ng-container>
          </div>
        </div>
      </li>
      <!-- ./Moderate menu -->

      <!-- Forum -->
      <li class="nav-item">
        <ng-container
          *ngIf="
            userProfile === null ||
              userProfile === undefined ||
              userProfile.enableNewForumExperience !== false ||
              isPwa;
            else classicForumDropdown
          "
        >
          <a [routerLink]="['/forum']" class="btn btn-link nav-link-padding" translate>Forum</a>
        </ng-container>

        <ng-template #classicForumDropdown>
          <div ngbDropdown>
            <button id="forumDropdown" class="btn btn-link" ngbDropdownToggle translate>Forum</button>
            <div [attr.aria-labelledby]="'forumDropdown'" ngbDropdownMenu>
              <a [href]="classicRoutesService.FORUM_HOME" class="dropdown-item">
                <fa-icon icon="comments"></fa-icon>
                {{ "Home" | translate }}
              </a>

              <a [href]="classicRoutesService.FORUM_LATEST" class="dropdown-item">
                <fa-icon icon="sort-amount-down"></fa-icon>
                {{ "Latest topics" | translate }}
              </a>

              <a [href]="classicRoutesService.FORUM_SUBSCRIBED" class="dropdown-item">
                <fa-icon icon="eye"></fa-icon>
                {{ "Subscribed topics" | translate }}
              </a>
            </div>
          </div>
        </ng-template>
      </li>
      <!-- ./Forum -->

      <!-- Marketplace -->
      <li class="nav-item">
        <a [routerLink]="['equipment', 'marketplace']" class="btn btn-link nav-link-padding" translate>Marketplace</a>
      </li>
      <!-- ./Marketplace -->

      <!-- Explore menu -->
      <li class="nav-item">
        <div ngbDropdown>
          <button id="exploreDropdown" class="btn btn-link" ngbDropdownToggle translate>Explore</button>
          <div [attr.aria-labelledby]="'exploreDropdown'" ngbDropdownMenu>
            <a [routerLink]="['/', 'search']" class="dropdown-item">
              <fa-icon icon="search"></fa-icon>
              {{ "Advanced search" | translate }}
            </a>

            <a [routerLink]="['equipment', 'explorer']" class="dropdown-item">
              <fa-icon icon="camera-retro"></fa-icon>
              {{ "Equipment" | translate }}
            </a>

            <a [routerLink]="['explore', 'constellations']" class="dropdown-item">
              <fa-icon icon="star"></fa-icon>
              {{ "Constellations" | translate }}
            </a>

            <a [routerLink]="['explore', 'iotd-tp-archive']" class="dropdown-item">
              <fa-icon icon="arrow-up"></fa-icon>
              {{ "IOTD/TP Archive" | translate }}
            </a>

            <a [href]="classicRoutesService.GROUPS" class="dropdown-item">
              <fa-icon icon="users"></fa-icon>
              {{ "Groups" | translate }}
            </a>

            <a [href]="classicRoutesService.REMOTE_ASTROPHOTOGRAPHY" class="dropdown-item">
              <fa-icon icon="laptop"></fa-icon>
              {{ "Remote astrophotography" | translate }}
            </a>

            <div class="dropdown-divider"></div>

            <a [routerLink]="['explore', 'astrophotographers-list']" class="dropdown-item">
              <fa-icon icon="chart-bar"></fa-icon>
              {{ "Astrophotographers list" | translate }}
            </a>
          </div>
        </div>
      </li>
      <!-- ./Explore menu -->

      <!-- Help menu -->
      <li class="nav-item">
        <div ngbDropdown>
          <button id="helpDropdown" class="btn btn-link" ngbDropdownToggle translate>Help</button>
          <div [attr.aria-labelledby]="'helpDropdown'" ngbDropdownMenu>
            <a [routerLink]="['/about/features']" class="dropdown-item">
              <fa-icon icon="info"></fa-icon>
              {{ "What is this site?" | translate }}
            </a>

            <div class="dropdown-divider"></div>

            <a [href]="classicRoutesService.FAQ" class="dropdown-item">
              <fa-icon icon="question"></fa-icon>
              {{ "FAQ" | translate }}
            </a>

            <div class="dropdown-divider"></div>

            <a [href]="classicRoutesService.HELP_API" class="dropdown-item">
              <fa-icon icon="key"></fa-icon>
              API
            </a>

            <a [href]="classicRoutesService.SPONSORS" class="dropdown-item">
              <fa-icon icon="users"></fa-icon>
              {{ "Sponsors & Partners" | translate }}
            </a>

            <a [href]="classicRoutesService.CONTACT" class="dropdown-item">
              <fa-icon icon="envelope"></fa-icon>
              {{ "Support" | translate }}
            </a>
          </div>
        </div>
      </li>
      <!-- ./Help menu -->
    </ul>

    <div class="d-none d-lg-block flex-grow-1">
      <ng-container [ngTemplateOutlet]="quickSearchTemplate"></ng-container>
    </div>

    <div class="d-block d-lg-none text-center w-100 mt-3">
      <h4 class="m-0 fw-bold">AstroBin</h4>
    </div>

    <ul class="navbar-nav mr-lg-auto mb-0 order-2 align-items-center">
      <ng-container [ngTemplateOutlet]="languageSelectorTemplate"></ng-container>

      <ng-container *ngIf="user; else loginAndRegisterMenubarTemplate">
        <li class="nav-item messages-list-item d-none d-lg-block">
          <ng-container [ngTemplateOutlet]="messagesButtonTemplate"></ng-container>
        </li>
        <li class="nav-item notifications-list-item d-none d-lg-block">
          <ng-container [ngTemplateOutlet]="notificationsButtonTemplate"></ng-container>
        </li>
        <ng-container [ngTemplateOutlet]="userMenuTemplate"></ng-container>
        <ng-container [ngTemplateOutlet]="uploadButtonTemplate"></ng-container>
      </ng-container>

      <ng-template #loginAndRegisterMenubarTemplate>
        <ng-container
          [ngTemplateOutlet]="loginAndRegisterTemplate"
          [ngTemplateOutletContext]="{ liClasses: 'd-none d-lg-block' }"
        ></ng-container>
      </ng-template>
    </ul>
  </div>
</ng-template>

<ng-template #userSidebarTemplate>
  <div #userSidebar class="order-lg-2 w-100 user-sidebar p-3 p-lg-0">
    <ul class="navbar-nav mr-lg-auto mb-0 order-1 order-lg-0 d-flex flex-column justify-content-center p-4 text-center">
      <li class="nav-item mb-3">
        <h5 class="pb-0">{{ user.displayName }}</h5>
        <ng-container [ngTemplateOutlet]="astrobinIndexTemplate"></ng-container>
      </li>

      <li class="nav-item">
        <a [routerLink]="subscriptionsRoute" class="nav-link">
          {{ "Subscriptions" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" routerLink="/uploader">
          {{ "Upload" | translate }}
        </a>
      </li>

      <li class="nav-item divider"></li>

      <li class="nav-item">
        <a *ngIf="user | isProducer" [href]="classicRoutesService.COMMERCIAL_PRODUCTS(user)" class="nav-link">
          {{ "Commercial products" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a
          [href]="userService.getGalleryUrl(user.username, userProfile.enableNewGalleryExperience)"
          (click)="userService.openGallery(user.username, userProfile.enableNewGalleryExperience)"
          class="nav-link"
          astrobinEventPreventDefault
        >
          {{ "Public Gallery" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a
          [href]="userService.getStagingUrl(user.username, userProfile.enableNewGalleryExperience)"
          (click)="userService.openStaging(user.username, userProfile.enableNewGalleryExperience)"
          class="nav-link"
        >
          {{ "Staging Area" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a [href]="classicRoutesService.BOOKMARKS(user)" class="nav-link">
          {{ "Bookmarks" | translate }}
        </a>
      </li>

      <li class="nav-item divider"></li>

      <li class="nav-item">
        <a class="nav-link" routerLink="/messages/inbox">
          {{ "Messages" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a [routerLink]="'/equipment/marketplace/users/' + user.username + '/listings'" class="nav-link">
          {{ "Marketplace listings" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a [href]="classicRoutesService.API_KEYS(user)" class="nav-link">
          {{ "API Keys" | translate }}
        </a>
      </li>

      <li class="nav-item divider"></li>

      <li class="nav-item">
        <a [href]="classicRoutesService.SETTINGS" class="nav-link">
          {{ "Settings" | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a (click)="toggleHighContrastTheme($event)" class="nav-link">
          <ng-container *ngIf="!useHighContrastTheme(); else highContrastThemeEnabled">
            {{ "Enable high contrast theme" | translate }}
          </ng-container>
        </a>
      </li>

      <li class="nav-item">
        <a (click)="logout($event)" class="nav-link" href="">
          {{ "Logout" | translate }}
        </a>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #astrobinIndexTemplate>
  <span
    *ngIf="
      !userProfile?.excludeFromCompetition &&
      userProfile?.astroBinIndex !== null &&
      userProfile?.contributionIndex !== null
    "
    [ngbPopover]="indexesPopoverContentTemplate"
    class="indexes"
    triggers="mouseenter:click"
  >
    <span class="image-index index">
      {{ userProfile?.astroBinIndex | number: "1.2-2" }}
      &middot;
    </span>
    <span class="contribution-index index">
      {{ userProfile?.contributionIndex | number: "1.2-2" }}
    </span>
  </span>
</ng-template>

<ng-template #highContrastThemeEnabled>
  {{ "Disable high contrast theme" | translate }}
</ng-template>

<ng-template #notificationsOffcanvas let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ "Notifications" | translate }}</h5>
    <button (click)="offcanvas.close()" class="btn-close text-reset"></button>
  </div>
  <div class="offcanvas-body">
    <astrobin-notifications-list [standalone]="true" (allNotificationsMarkedAsRead)="offcanvas.close()">
    </astrobin-notifications-list>
  </div>
</ng-template>

<!-- Version update modal -->
<ng-template #versionUpdateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ "Update available" | translate }}</h5>
    <button (click)="modal.dismiss()" class="btn-close" type="button"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">
      {{
        "A new version of AstroBin is available. Please refresh the page to get the latest features and improvements."
          | translate
      }}
    </p>
  </div>
  <div class="modal-footer">
    <button (click)="onIgnoreUpdateClick()" class="btn btn-outline-secondary" type="button">
      {{ "Ignore" | translate }}
    </button>
    <button (click)="onRefreshClick()" class="btn btn-primary" type="button">
      {{ "Refresh" | translate }}
    </button>
  </div>
</ng-template>

<!-- Version update offcanvas -->
<ng-template #versionUpdateOffcanvas let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ "Update available" | translate }}</h5>
    <button (click)="offcanvas.dismiss()" class="btn-close text-reset" type="button"></button>
  </div>
  <div class="offcanvas-body">
    <p class="mb-4">
      {{
        "A new version of AstroBin is available. Please refresh the page to get the latest features and improvements."
          | translate
      }}
    </p>
    <div class="d-grid gap-2">
      <button (click)="onRefreshClick()" class="btn btn-primary" type="button">
        {{ "Refresh" | translate }}
      </button>
      <button (click)="onIgnoreUpdateClick()" class="btn btn-outline-secondary" type="button">
        {{ "Ignore" | translate }}
      </button>
    </div>
  </div>
</ng-template>
